const ViolinChartData = [
    {
      "projectId": 1,
      "projectName": "Residential Construction",
      "task": "Foundation Work",
      "taskDurationDays": 30,
      "costEstimateUSD": 15000,
      "riskLevel": 4,
      "resourcesAllocated": 5,
      "clientSatisfactionScore": 7,
      "contractorPerformanceScore": 8,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 2,
      "projectName": "Office Building",
      "task": "Steel Framework",
      "taskDurationDays": 45,
      "costEstimateUSD": 45000,
      "riskLevel": 6,
      "resourcesAllocated": 10,
      "clientSatisfactionScore": 9,
      "contractorPerformanceScore": 7,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
      "projectId": 3,
      "projectName": "Mall Renovation",
      "task": "Demolition",
      "taskDurationDays": 10,
      "costEstimateUSD": 12000,
      "riskLevel": 3,
      "resourcesAllocated": 3,
      "clientSatisfactionScore": 8,
      "contractorPerformanceScore": 8,
      "milestoneTiming": "Behind Schedule"
    },
    {
      "projectId": 4,
      "projectName": "Road Expansion",
      "task": "Paving",
      "taskDurationDays": 25,
      "costEstimateUSD": 25000,
      "riskLevel": 5,
      "resourcesAllocated": 6,
      "clientSatisfactionScore": 6,
      "contractorPerformanceScore": 5,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 5,
      "projectName": "Bridge Construction",
      "task": "Bridge Decking",
      "taskDurationDays": 60,
      "costEstimateUSD": 75000,
      "riskLevel": 8,
      "resourcesAllocated": 12,
      "clientSatisfactionScore": 5,
      "contractorPerformanceScore": 6,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
      "projectId": 6,
      "projectName": "Commercial Tower",
      "task": "Excavation",
      "taskDurationDays": 35,
      "costEstimateUSD": 32000,
      "riskLevel": 7,
      "resourcesAllocated": 9,
      "clientSatisfactionScore": 9,
      "contractorPerformanceScore": 9,
      "milestoneTiming": "Behind Schedule"
    },
    {
      "projectId": 7,
      "projectName": "University Campus",
      "task": "Electrical Work",
      "taskDurationDays": 20,
      "costEstimateUSD": 15000,
      "riskLevel": 4,
      "resourcesAllocated": 4,
      "clientSatisfactionScore": 7,
      "contractorPerformanceScore": 8,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 8,
      "projectName": "Highway Construction",
      "task": "Earthwork",
      "taskDurationDays": 50,
      "costEstimateUSD": 60000,
      "riskLevel": 6,
      "resourcesAllocated": 8,
      "clientSatisfactionScore": 8,
      "contractorPerformanceScore": 7,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
      "projectId": 9,
      "projectName": "Hospital Expansion",
      "task": "Interior Design",
      "taskDurationDays": 40,
      "costEstimateUSD": 40000,
      "riskLevel": 5,
      "resourcesAllocated": 5,
      "clientSatisfactionScore": 6,
      "contractorPerformanceScore": 6,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 10,
      "projectName": "Warehouse Setup",
      "task": "Roofing",
      "taskDurationDays": 15,
      "costEstimateUSD": 20000,
      "riskLevel": 3,
      "resourcesAllocated": 3,
      "clientSatisfactionScore": 9,
      "contractorPerformanceScore": 9,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 11,
      "projectName": "Airport Terminal",
      "task": "Security Systems",
      "taskDurationDays": 55,
      "costEstimateUSD": 70000,
      "riskLevel": 8,
      "resourcesAllocated": 12,
      "clientSatisfactionScore": 7,
      "contractorPerformanceScore": 6,
      "milestoneTiming": "Behind Schedule"
    },
    {
      "projectId": 12,
      "projectName": "Luxury Hotel",
      "task": "Plumbing",
      "taskDurationDays": 18,
      "costEstimateUSD": 22000,
      "riskLevel": 4,
      "resourcesAllocated": 4,
      "clientSatisfactionScore": 8,
      "contractorPerformanceScore": 7,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
      "projectId": 13,
      "projectName": "Residential Complex",
      "task": "Painting",
      "taskDurationDays": 12,
      "costEstimateUSD": 10000,
      "riskLevel": 3,
      "resourcesAllocated": 2,
      "clientSatisfactionScore": 10,
      "contractorPerformanceScore": 10,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 14,
      "projectName": "Shopping Plaza",
      "task": "HVAC Installation",
      "taskDurationDays": 38,
      "costEstimateUSD": 35000,
      "riskLevel": 5,
      "resourcesAllocated": 7,
      "clientSatisfactionScore": 6,
      "contractorPerformanceScore": 5,
      "milestoneTiming": "Behind Schedule"
    },
    {
      "projectId": 15,
      "projectName": "Office Space",
      "task": "Windows Installation",
      "taskDurationDays": 14,
      "costEstimateUSD": 13000,
      "riskLevel": 2,
      "resourcesAllocated": 3,
      "clientSatisfactionScore": 7,
      "contractorPerformanceScore": 8,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
      "projectId": 16,
      "projectName": "Library Renovation",
      "task": "Masonry",
      "taskDurationDays": 28,
      "costEstimateUSD": 25000,
      "riskLevel": 6,
      "resourcesAllocated": 6,
      "clientSatisfactionScore": 8,
      "contractorPerformanceScore": 7,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 17,
      "projectName": "Park Development",
      "task": "Landscaping",
      "taskDurationDays": 20,
      "costEstimateUSD": 18000,
      "riskLevel": 3,
      "resourcesAllocated": 4,
      "clientSatisfactionScore": 9,
      "contractorPerformanceScore": 9,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
      "projectId": 18,
      "projectName": "School Building",
      "task": "Flooring",
      "taskDurationDays": 25,
      "costEstimateUSD": 20000,
      "riskLevel": 4,
      "resourcesAllocated": 5,
      "clientSatisfactionScore": 6,
      "contractorPerformanceScore": 6,
      "milestoneTiming": "Behind Schedule"
    },
    {
      "projectId": 19,
      "projectName": "Residential Villas",
      "task": "Plastering",
      "taskDurationDays": 10,
      "costEstimateUSD": 8000,
      "riskLevel": 2,
      "resourcesAllocated": 3,
      "clientSatisfactionScore": 10,
      "contractorPerformanceScore": 10,
      "milestoneTiming": "On Time"
    },
    {
      "projectId": 20,
      "projectName": "Industrial Plant",
      "task": "Equipment Setup",
      "taskDurationDays": 60,
      "costEstimateUSD": 80000,
      "riskLevel": 9,
      "resourcesAllocated": 15,
      "clientSatisfactionScore": 5,
      "contractorPerformanceScore": 6,
      "milestoneTiming": "Behind Schedule"
    },
    {
      "projectId": 21,
      "projectName": "Data Center",
      "task": "Server Installation",
      "taskDurationDays": 45,
      "costEstimateUSD": 50000,
      "riskLevel": 7,
      "resourcesAllocated": 10,
      "clientSatisfactionScore": 8,
      "contractorPerformanceScore": 7,
      "milestoneTiming": "Ahead of Schedule"
    },
    {
        "projectId": 22,
        "projectName": "Data Center",
        "task": "Server Installation",
        "taskDurationDays": 45,
        "costEstimateUSD": 50000,
        "riskLevel": 7,
        "resourcesAllocated": 10,
        "clientSatisfactionScore": 8,
        "contractorPerformanceScore": 7,
        "milestoneTiming": "Ahead of Schedule"
      },
      {
        "projectId": 23,
        "projectName": "Shopping Mall",
        "task": "Escalator Installation",
        "taskDurationDays": 35,
        "costEstimateUSD": 40000,
        "riskLevel": 5,
        "resourcesAllocated": 7,
        "clientSatisfactionScore": 6,
        "contractorPerformanceScore": 5,
        "milestoneTiming": "On Time"
      },
      {
        "projectId": 24,
        "projectName": "Hospital Setup",
        "task": "Medical Equipment Installation",
        "taskDurationDays": 55,
        "costEstimateUSD": 90000,
        "riskLevel": 8,
        "resourcesAllocated": 14,
        "clientSatisfactionScore": 7,
        "contractorPerformanceScore": 6,
        "milestoneTiming": "Ahead of Schedule"
      },
      {
        "projectId": 25,
        "projectName": "Warehouse Expansion",
        "task": "Storage Racking Setup",
        "taskDurationDays": 25,
        "costEstimateUSD": 30000,
        "riskLevel": 4,
        "resourcesAllocated": 6,
        "clientSatisfactionScore": 9,
        "contractorPerformanceScore": 8,
        "milestoneTiming": "On Time"
      }
];

export default ViolinChartData;

    